import React from 'react'
import { Route } from 'react-router-dom'
import Inner from './Inner'

export default () => <Route path='/dashboard' component={Inner} />
